<script lang="ts">
    import type {RichRecord} from '../../typings/portaro.be.types';
    import {INJECTOR_KEY, LOCALIZE_KEY} from '../../svelte/utils';
    import {KpCoverPresenter} from './kp-cover.presenter';
    import type {Injector, LocalizeFunction} from '../../svelte/types';
    import {getContext} from 'svelte';

    type TTarget = 'cover' | 'record';
    type TFillTo = 'width' | 'height';

    export let record: RichRecord = null;
    export let href: string = null;
    export let fillTo: TFillTo = null;
    export let target: TTarget = 'record';

    const injector: Injector = getContext(INJECTOR_KEY);
    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);

    const presenter: KpCoverPresenter = injector.getByToken(KpCoverPresenter.presenterName);

    const fillWidth = fillTo === 'width';
    const fillHeight = fillTo === 'height';
    $: imgSrc = presenter.getCoverPath(record);

    let enableZoomCursor = false;
    let onClickFunction: () => void = null;
    let linkHref: string = null;

    if (!!href) {
        linkHref = href;
    } else if (!!record) {
        if (target === 'cover') {
            onClickFunction = () => { presenter.openMediaViewer(record) };
            enableZoomCursor = true;
        } else if (target === 'record') {
            linkHref = presenter.getRecordPath(record);
        }
    }

    function generateAltText() {
        if (target === 'cover') {
            return `${localize(/* @kp-localization record.Cover */ 'record.Cover')}: ${record.name} (${localize(/* @kp-localization record.ClickToShowCover */ 'record.ClickToShowCover')})`;
        } else {
            return `${localize(/* @kp-localization record.Cover */ 'record.Cover')}: ${record.name} (${localize(/* @kp-localization record.ClickToShowRecord */ 'record.ClickToShowRecord')})`;
        }
    }
</script>

<template>
    <div class="cover-container">
        {#if !!linkHref}
            <a class="cover-link" href={linkHref} class:zoom-in-cursor={enableZoomCursor}>
                <img class="obalImg" src={imgSrc} class:fill-width={fillWidth} class:fill-height={fillHeight} alt={generateAltText()}>
            </a>
        {:else if !!onClickFunction}
            <!-- svelte-ignore a11y-invalid-attribute allow javascript:void(0) in href -->
            <a class="cover-link" href="javascript:void(0)" on:click={onClickFunction} class:zoom-in-cursor={enableZoomCursor}>
                <img class="obalImg" src={imgSrc} class:fill-width={fillWidth} class:fill-height={fillHeight} alt={generateAltText()}>
            </a>
        {:else}
            <img class="obalImg" src={imgSrc} class:fill-width={fillWidth} class:fill-height={fillHeight} alt={generateAltText()}>
        {/if}
    </div>
</template>

<style lang="less">
  .cover-container{
    width: 100%;
    height: 100%;
  }

  img.fill-width {
    width: 100%;
    height: auto;
  }

  img.fill-height {
    height: 100%;
    width: auto;
    margin: 0 auto;
  }

  .zoom-in-cursor {
    cursor: zoom-in;
  }
</style>